module.exports = __webpack_public_path__ + "static/media/logo blanco.104cc768.png";